import { DocumentNode } from 'graphql'
import cookies from 'js-cookie'
import { decorateFetch } from '../../../../api'

export const getQueries = (
  pageQuery: (id: string) => DocumentNode,
  aggregationsQuery: (id: string) => DocumentNode,
  quickFiltersQuery: (id: string) => DocumentNode,
  id: string
) => ({
  pageQuery: pageQuery(id),
  aggregationsQuery: aggregationsQuery(id),
  quickFiltersQuery: quickFiltersQuery(id)
})

export const getLibrary = async (
  organizationID: string,
  language: string,
  hash: string
): Promise<any> => {
  const url = `/Contrast/api/ng/${organizationID}/libraries/${language}/${hash}?expand=apps&expand=vulns`

  let res
  try {
    const decoratedFetch = decorateFetch(
      fetch,
      cookies,
      document.location,
      window.localStorage
    )

    res = await decoratedFetch(url, {
      method: 'GET'
    })
  } catch {
    throw Error('could not fetch the data for that resource')
  }

  return res.json()
}
